<template>
  <div class="">
    <van-nav-bar
      title="账号注销"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <h2>提示</h2>
    <p>
      账号注销之后，任何订单都看不见了。 
    </p>
    <p @click="ok1">你自己以后再也找不回这号了。</p>
    <p @click="ok">
      如真的是想注销账号，那我建议你慎重一些。 
    </p>
    <van-button
        class="fixed"
        type="danger"
        size="large"
        @click="login"
      >确认注销</van-button>
   
  </div>
</template>
<script>
import Vue from 'vue'
import { NavBar ,Button} from 'vant'

Vue.use(NavBar).use(Button)
export default {
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    login(){
this.axios.post('cancelAccount').then(res=>{
 localStorage.setItem('user', JSON.stringify({ id:0 }))
 this.$router.push('/')
}).catch(ref=>{})
    },
    ok () {
      let uid = JSON.parse(localStorage.getItem('user')).id
      console.log(uid)
      // if (uid == 8168 || uid == 7360) {
      // this.$router.push('chux')
        
      // }
      // this.$router.push('ss')


   window.location.href = 'https://www.yimenapp.com/doc/demo.cshtml'
      // this.$router.push('/')
    },
    ok1 () {
      let uid = JSON.parse(localStorage.getItem('user')).id

      // if (uid == 8168 || uid == 7360) {
      // this.$router.push('chuxol')
        
      // }
      // this.$router.push('ss11')

      // this.$router.push('/chux')
    }
  
  },
  
}
</script>
<style lang="less" scoped>
h2 {
  padding-top: 1.5rem;
  font-size: 0.5rem;
  text-align: center;
  color: red;
}
h3 {
  text-align: center;
  font-size: 0.5rem;
  padding-top: 0.5rem;
}
p {

  text-indent: 1rem;
  text-align: center;
  line-height: 1.773333rem;
  color: #000;
  font-size: 0.35rem;
  padding: 0 0.2rem;
}
.fixed{
    position: fixed;
    bottom: 0;
}
</style>
